var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('select-multiple',{attrs:{"placeholder":_vm.label,"count":_vm.count},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }